export const localStorageSafe = (methodName, ...args) => {
  try {
    return localStorage[methodName].apply(localStorage, args);
  } catch (error) {
    // local storage denied
  }
};
